import React from 'react';
import { Icon } from '@odin-labs/components';

export function AttributeDescription({
  label,
  value,
  values,
  icon: IconComponent,
  valueClassName = '',
}: {
  label: string;
  value?: string | React.ReactNode;
  values?: string[];
  icon?: Icon;
  valueClassName?: string;
}): React.ReactElement {
  const fullValueClassName = `odin-block odin-text-base odin-font-normal odin-text-gray-900 ${valueClassName}`;
  return (
    <div className="odin-col-span-1">
      <div className="odin-field odin-flex odin-justify-between odin-items-center">
        <div className="odin-mb-1.5 odin-block odin-text-sm odin-font-medium odin-text-gray-900">
          {label}
        </div>
      </div>
      <div className="odin-flex odin-item-start odin-gap-2 odin-items-baseline">
        {IconComponent && <IconComponent className="odin-text-odin-primary" />}
        <div className={fullValueClassName}>{value || values?.join(', ')}</div>
      </div>
    </div>
  );
}
